var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useState, useRef, useEffect } from "react";
import Polyglot from "node-polyglot";
import PolyglotContext from "./context";
var interpolation = { prefix: "{", suffix: "}" };
export default function I18n(props) {
  var locale = props.locale,
      phrases = props.phrases,
      options = props.options,
      children = props.children;

  var inited = useRef(false);

  var _useState = useState(new Polyglot(_extends({
    interpolation: interpolation
  }, options, {
    locale: locale,
    phrases: phrases
  }))),
      polyglot = _useState[0],
      setPolyglot = _useState[1];

  //Recreate polyglot instance to trigger context update
  //NOTE: Can be changed for a useRef and change context to by a updatable function with only the t method.


  useEffect(function () {
    if (inited.current) {
      setPolyglot(new Polyglot(_extends({
        interpolation: interpolation
      }, options, {
        locale: locale,
        phrases: phrases
      })));
    } else {
      inited.current = true;
    }
  }, [locale, phrases, options]);

  return React.createElement(
    PolyglotContext.Provider,
    { value: polyglot },
    children
  );
}